import gql from 'graphql-tag'

export const teamQuotesQuery = gql`
    query TeamQuotes(
        $teamId: Int!
        $filters: TeamQuoteAndOrderFilterInput
        $limit: Int
        $offset: Int
        $userId: Int
    ) {
        teamQuotes(
            teamId: $teamId
            filters: $filters
            limit: $limit
            offset: $offset
            userId: $userId
        ) {
            items {
                id
                lastModified
                name
                createdAt
                user {
                    email
                    id
                }
                quoteModels(limit: 4) {
                    totalCount
                    items {
                        id
                        quoteModelRevisions {
                            partRevision {
                                thumbnailUri
                            }
                        }
                    }
                }
                subTotalInCents
            }
            totalCount
        }
    }
`
